import { Component } from '@angular/core';
import { PolicyHeaderComponent } from '../policy-header/policy-header.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-shipping-exchange-policy',
    imports: [PolicyHeaderComponent, CommonModule],
    templateUrl: './shipping-exchange-policy.component.html',
    styleUrl: '../policy-page.css'
})
export class ShippingExchangePolicyComponent {
  isLogin = false;
  ngOnInit() {
    this.isLogin = localStorage.getItem('isLogedIn') === 'true';
  }
}
